const generateEndPoint = ({ source, path }) => {
    const endPointPaths = []

    endPointPaths.push(path)

    if (source === 'elastic') {
        endPointPaths.push('_search')
    }

    return endPointPaths.join('/') + '/'
}

const generateFilter = (params) => {
    let field, is, value

    if (params.length === 3) {
        [field, is, value] = params
    } else {
        [field, value] = params
        is = '='
    }

    return {
        field,
        is,
        value
    }
}

const generateQuery = ({ source, filters = [] }) => {
    const ranges = {
        '>': 'gt',
        '>=': 'gte',
        '<': 'lt',
        '<=': 'lte'
    }

    if (source === 'elastic') {
        const query = {
            bool: {
                must: []
            }
        }

        for (const group of filters) {
            const must_not = []
            const should = []

            for (const filter of group) {
                if (Array.isArray(filter)) {
                    const subQuery = generateQuery({ source, filters: filter })
                    should.push(subQuery)
                } else {
                    if (Array.isArray(filter.value)) {
                        should.push({
                            terms: {
                                [filter.field]: filter.value
                            }
                        })

                        continue
                    }

                    if (filter.field === 'geo_bounding_box') {
                        should.push({
                            geo_bounding_box: filter.value
                        })

                        continue
                    }

                    const match = {
                        [filter.field]: filter.value
                    }

                    if (filter.is === '!=') {
                        must_not.push({
                            match
                        })

                        continue
                    } else if (filter.is === '!+') {
                        should.push({
                            exists: {
                                field: filter.field
                            }
                        })

                        continue
                    } else if (filter.is === '!-') {
                        must_not.push({
                            exists: {
                                field: filter.field
                            }
                        })

                        continue
                    } else if (ranges[filter.is]) {
                        const range = {}

                        range[filter.field] = {}
                        range[filter.field][ranges[filter.is]] = filter.value

                        should.push({
                            range
                        })

                        continue
                    }

                    should.push({
                        match
                    })
                }
            }

            query.bool.must.push({
                bool: { must_not, should }
            })
        }

        return query
    } else {
        const query = {
            $and: []
        }

        for (const group of filters) {
            const or = []

            for (const filter of group) {
                if (Array.isArray(filter)) {
                    const subQuery = generateQuery({ source, filters: filter })
                    or.push(subQuery)
                } else {
                    const match = {}
                    match[filter.field] = filter.value

                    if (Object.values(match).length) {
                        or.push(match)
                    }
                }
            }

            query.$and.push({
                $or: or
            })
        }

        return query
    }
}

const formatResult = (source, params = {}, result) => {
    const { data } = result

    if (source === 'elastic') {
        const { hits } = data

        if (hits) {
            const {
                total: { value }
            } = hits
            const perPage = params.limit
            const lastPage = value ? Math.ceil(value / perPage) : 0

            return {
                data: hits.hits.map((hit) => {
                    const source = hit._source

                    if (hit._highlight) {
                        source._highlight = hit._highlight
                    }

                    return source
                }),
                currentPage: params.page,
                lastPage,
                perPage,
                total: value
            }
        }
    }

    return {}
}

const prepareTranslit = (value) => {
    if (!value) {
        return ''
    }

    const replace = {
        kh: 'x',
        gh: 'x',
        ts: 'c'
    }

    let translit = `${value}`
    for (const key of Object.keys(replace)) {
        if (translit.includes(replace[key])) {
            translit += ` ${`${value}`.replace(replace[key], key)}`
        }
    }

    return translit
}

const cache = async (key, callback) => {
    let cacheStorage

    // /* eslint-disable */
    // if (typeof navigator !== "undefined" && navigator.product === "ReactNative") {
    //   const { AsyncStorage } = require("react-native");
    //   cacheStorage = AsyncStorage;
    // } else if (typeof window !== "undefined" && window.localStorage) {
    //   cacheStorage = localStorage;
    // }
    // /* eslint-enable */

    let cached = cacheStorage ? await cacheStorage.getItem(key) : null

    if (!cached) {
        cached = JSON.stringify(await callback())

        if (cacheStorage) {
            cacheStorage.setItem(key, cached)
        }
    }

    return JSON.parse(cached)
}

module.exports = {
    generateEndPoint,
    generateFilter,
    generateQuery,
    formatResult,
    prepareTranslit,
    cache
}
